// API base URL - automatically uses proxy in development, direct URL in production
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '' // Production'da same-origin
  : 'http://localhost:8000'; // Development'ta direkt backend URL

export const apiUrl = (path) => {
  // Eğer path zaten tam URL ise, olduğu gibi dön
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Development'ta direkt backend URL kullan
  if (process.env.NODE_ENV === 'development') {
    return `${API_BASE_URL}${path}`;
  }
  
  // Production'da relative path kullan
  return path;
};

export default apiUrl;

